import { TranslationKeysMapper } from '../translation-keys.model';
import { TranslationKeys } from './translation-keys.enum';

export enum Language {
  English = 'en',
  German = 'de',
  Danish = 'da',
  Dutch = 'nl',
  French = 'fr',
  Italian = 'it',
  Spanish = 'es',
  Swedish = 'sv',
  Debug = 'debug',
}

export enum DateFormat {
  English = 'en',
  UK = 'en-GB',
  German = 'de',
  Danish = 'da',
  Dutch = 'nl',
  French = 'fr',
  Italian = 'it',
  Spanish = 'es',
  Swedish = 'sv',
  Debug = 'debug',
}

// Debug is offered only here, and only to Luware sys admins.
export const debugLanguageEnvironments = ['stage', 'local'];

export const languageTranslationKeys: TranslationKeysMapper<Language | DateFormat> = {
  de: TranslationKeys.LanguageSelectorGerman,
  en: TranslationKeys.LanguageSelectorEnglish,
  ['en-GB']: TranslationKeys.LanguageSelectorEnglishUK,
  fr: TranslationKeys.LanguageSelectorFrench,
  it: TranslationKeys.LanguageSelectorItalian,
  nl: TranslationKeys.LanguageSelectorDutch,
  da: TranslationKeys.LanguageSelectorDanish,
  es: TranslationKeys.LanguageSelectorSpanish,
  sv: TranslationKeys.LanguageSelectorSwedish,
  debug: 'Debug' as TranslationKeys,
};
